export function base64Config(schemaFormProvider, schemaFormDecoratorsProvider, sfBuilderProvider, sfPathProvider) {
	const base64file = function(name, schema, options) {
		if(schema.type === "string" && schema.format === "base64") {
			const f = schemaFormProvider.stdFormObj(name, schema, options);
			f.key  = options.path;
			f.type = "base64file";
			options.lookup[sfPathProvider.stringify(options.path)] = f;

			return f;
		}
	};

	schemaFormProvider.defaults.string.unshift(base64file);

	schemaFormDecoratorsProvider.defineAddOn(
		"bootstrapDecorator",           // Name of the decorator you want to add to.
		"base64file",                      // Form type that should render this add-on
		"./templates/base-64-upload/template.html",  // Template name in $templateCache
		sfBuilderProvider.stdBuilders   // List of builder functions to apply
	);
}